import gql from "graphql-tag";

export const CREATE_EVENT_QUERY = gql`mutation CreateEvent($professional: EventProfessional!, $event: json) {
    create_event(professional: $professional, event: $event) {
        created
        event {
            id
            meet {
                url
            }
        }
    }
  }
  `